<template>
  <div class="qrcode">
    <v-toolbar dark class="toolbarqrcode"  style="margin-top: 20px;">
      <img :src="BASE_URL + 'static/icon/qrcode.svg'" alt="" width="40px"> &nbsp;&nbsp;
      <v-toolbar-title>สร้าง QR Code</v-toolbar-title>
    </v-toolbar>
    <div  class="horizontal-center widthdivstep">
       <v-stepper v-model="StepCreate">
      <v-stepper-header>
        <v-stepper-step step="1">รูปแบบการสร้าง</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2">ข้อมูลเพิ่มเติม</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">สำเร็จ</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
      <v-stepper-content step="1">
        <v-card color="grey lighten-2" class="pd-10" style="max-height: 200px;margin-bottom: 20px;">
          <!-- {{radioGroup}} -->
          <v-radio-group v-model="radioGroup" >
            <v-radio
              v-for="n in 2"
              :key="n"
              :value="n"
              :label="(n == 1)? 'สร้าง QRcode 1 โค้ด':'สร้าง QRcode จำนวนมาก'"
              color="#aa0800ff"
            ></v-radio>


          </v-radio-group>
          <p v-if="typeCompanyDecode == 'owner'" style="text-align: left; margin-bottom: 0;">บริษัทเจ้าของเครื่อง AED <span style="color: red !important;">*</span>
          </p>
          <v-select
            :items="itemsCompanyOwner"
            item-text="company_name"
            item-value="company_id"
            v-model="CompanyOwner"
            label="เลือกเจ้าของเครื่อง AED"
            outlined
            hide-details
            single-line
            v-if="typeCompanyDecode == 'owner'"
          ></v-select>
        </v-card>
        <v-btn rounded @click="StepCreate = 2" :disabled="(radioGroup == 0) || (CompanyOwner == '')" color="primary" style="color: white; margin-bottom: 10px;">ถัดไป</v-btn>
      </v-stepper-content>
      <v-stepper-content step="2" v-if="radioGroup == 1">
        <v-card color="grey lighten-2" class="pd-10" height="378px"  style="margin-bottom: 20px; overflow: scroll;">
          <p style="text-align: left; margin-bottom: 0;">บริษัทที่ดูแลเครื่อง <span style="color: red !important;">*</span>
            <v-tooltip bottom v-if="itemsCompany.length != 0">
            <template v-slot:activator="{ on }">
              <v-icon @click="dialogcreate_company = true" v-on="on" style="font-size: 18px;color: rgb(168, 14, 0);float: right; cursor: pointer;">fas fa-plus-circle
              </v-icon>
            </template>
            <span>สร้างบริษัทดูแลเครื่อง</span>
          </v-tooltip>
          
          </p>
          <v-select
            :items="itemsCompany"
            item-text="company_name"
            item-value="company_id"
            v-model="CompanyMaintenance"
            label="เลือกบริษัทที่ดูแลเครื่อง"
            outlined
            hide-details
            single-line
            style="margin-bottom: 10px;"
            v-if="itemsCompany.length != 0"
          ></v-select>
          <v-btn rounded style="background: #a80e00; color: white;" v-else @click="dialogcreate_company = true">
            <v-icon style="font-size: 14px;">fas fa-plus-circle</v-icon> &nbsp; สร้างบริษัทดูแลเครื่อง
          </v-btn>
          <p style="text-align: left; margin-bottom: 0;">Serial Number <span style="color: red !important;">*</span></p>
          <v-text-field
            label="Serial Number"
            single-line
            outlined
            hide-details
            v-model="SerialNum"
            style="margin-bottom: 10px;"
          ></v-text-field>
          
          <p style="text-align: left; margin-bottom: 0;">วันหมดอายุของ แบตเตอร์รี่ <span style="color: red !important;">*</span></p>
          <v-menu
            v-model="pickerMonthBat"
            :close-on-content-click="false"
            max-width="290"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="ExpireBat"
                clearable
                single-line
                outlined
                label="วันหมดอายุของ แบตเตอร์รี่"
                readonly
                hide-details
                v-on="on"
                style="margin-bottom: 10px;"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="ExpireBatPicker"
              type="month"
              locale="th"
              @change="pickerMonthBat = false"
            ></v-date-picker>
          </v-menu>
          <p style="text-align: left; margin-bottom: 0;">วันหมดอายุของ Pad <span style="color: red !important;">*</span></p>
          <v-menu
            v-model="pickerMonthPad"
            :close-on-content-click="false"
            max-width="290"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="ExpirePad"
                clearable
                single-line
                outlined
                label="วันหมดอายุของ Pad"
                readonly
                hide-details
                v-on="on"
                style="margin-bottom: 10px;"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="ExpirePadPicker"
              type="month"
              locale="th"
              @change="pickerMonthPad = false"
            ></v-date-picker>
          </v-menu>
       
        </v-card>
        <v-btn rounded text style="margin-bottom: 10px;" @click="StepCreate = 1">ย้อนกลับ</v-btn> &nbsp;&nbsp;&nbsp;
        <v-btn rounded color="primary" style="color: white; margin-bottom: 10px;" @click="CreateQRcode()" :disabled="CompanyMaintenance == '' || SerialNum == '' || ExpireBat == '' || ExpirePad == ''">ถัดไป</v-btn>
      </v-stepper-content>

      <v-stepper-content step="2" v-if="radioGroup == 2">
        <v-card color="grey lighten-2" class="pd-10" height="378px"  style="margin-bottom: 20px; overflow: scroll;">
          <p style="text-align: left; margin-bottom: 0;">บริษัทที่ดูแลเครื่อง <span style="color: red !important;">*</span>
            <v-tooltip bottom v-if="itemsCompany.length != 0">
            <template v-slot:activator="{ on }">
              <v-icon @click="dialogcreate_company = true" v-on="on" style="font-size: 18px;color: rgb(168, 14, 0);float: right; cursor: pointer;">fas fa-plus-circle
              </v-icon>
            </template>
            <span>สร้างบริษัทดูแลเครื่อง</span>
          </v-tooltip>
          </p>
          <!-- {{itemsCompany}} -->

          <v-select
            :items="itemsCompany"
            item-text="company_name"
            item-value="company_id"
            v-model="CompanyMaintenance"
            label="เลือกบริษัทที่ดูแลเครื่อง"
            outlined
            hide-details
            single-line
            style="margin-bottom: 10px;"
            v-if="itemsCompany.length != 0"
          ></v-select>
          <v-btn rounded style="background: #a80e00; color: white;" v-else @click="dialogcreate_company = true">
            <v-icon style="font-size: 14px;">fas fa-plus-circle</v-icon> &nbsp; สร้างบริษัทดูแลเครื่อง
          </v-btn>
          <p style="text-align: left; margin-bottom: 0;">จำนวน Qrcode <span style="color: red !important;">*</span></p>
          <v-text-field
            label="จำนวน Qrcode ที่ต้องการสร้าง"
            single-line
            outlined
            hide-details
            v-model="NumQRcode"
            type=number
            min=1
            style="margin-bottom: 10px;"
          ></v-text-field>
          <p style="text-align: left; margin-bottom: 0;">วันหมดอายุของ แบตเตอร์รี่ (ถ้ามี)</p>
          <v-menu
            v-model="pickerMonthBat"
            :close-on-content-click="false"
            max-width="290"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="ExpireBat"
                clearable
                single-line
                outlined
                label="วันหมดอายุของ แบตเตอร์รี่"
                readonly
                hide-details
                v-on="on"
                style="margin-bottom: 10px;"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="ExpireBatPicker"
              type="month"
              locale="th"
              @change="pickerMonthBat = false"
            ></v-date-picker>
          </v-menu>
          <p style="text-align: left; margin-bottom: 0;">วันหมดอายุของ Pad (ถ้ามี)</p>
          <v-menu
            v-model="pickerMonthPad"
            :close-on-content-click="false"
            max-width="290"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="ExpirePad"
                clearable
                single-line
                outlined
                label="วันหมดอายุของ Pad"
                readonly
                hide-details
                v-on="on"
                style="margin-bottom: 10px;"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="ExpirePadPicker"
              type="month"
              locale="th"
              @change="pickerMonthPad = false"
            ></v-date-picker>
          </v-menu>
       
        </v-card>
        <v-btn rounded text @click="StepCreate = 1" style="margin-bottom: 10px;" >ย้อนกลับ</v-btn> &nbsp;&nbsp;&nbsp;
        <!-- {{CompanyMaintenance}} -->
        <v-btn rounded color="primary" style="color: white; margin-bottom: 10px;" @click="CreateQRcode()" :disabled="CompanyMaintenance == ''">ถัดไป</v-btn>
      </v-stepper-content>

       <v-stepper-content step="3">
        <v-card color="grey lighten-2" class="pd-10" style="max-height:350px; overflow: scroll; margin-bottom: 20px;">
          <div v-if="qrcode.length == 1">
            <qrcode :value="API_FRONTEND + 'AEDQRcode/' + qrcode[0]['qrcode_id']" style="width: 180px;" :id="'downloadqr'"></qrcode>
          </div>

          <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn rounded icon type="button" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="generate_id" v-on="on">
            <v-icon style="color: #5f5f5f; font-size: 16px !important;">file_copy</v-icon>
          </v-btn>
        </template>
        <span>Copy Generate ID</span>
      </v-tooltip>
          <p style="text-align: left; margin-bottom: 0; margin-top: 20px;"><b>Generate ID:</b> {{generate_id}}</p>
          <p style="text-align: left; margin-bottom: 0; margin-top: 20px;"><span style="color: red !important;">*</span> สามารถดูข้อมูลที่ทำการสร้างได้จากส่วนของ Report/ข้อมูล QR Code โดยค้นหาจาก Generate ID  หรือ <span @click="gotodetail" style="color: #a80d00; text-decoration: underline; font-weight: 800;cursor: pointer;">กดที่นี่</span> เพื่อแสดงข้อมูล</p>
        </v-card>
        <!-- <v-btn text @click="StepCreate = 2">ย้อนกลับ</v-btn> -->
        <v-btn rounded color="primary" style="color: white; margin-bottom: 10px;" @click="successQrcode()">สำเร็จ</v-btn>
      </v-stepper-content>
    </v-stepper-items>
    </v-stepper>

    </div>
    <CreateCompany :dialogcreate_company="dialogcreate_company" typeCompany="maintenance" :headid="CompanyOwner" @closecreate_company="closecreate_company"></CreateCompany>
  </div>
</template>

<script>
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
import { Decode } from '@/services'
import CreateCompany from '@/components/create/create_company_modal'
Vue.component(VueQrcode.name, VueQrcode)
var _ = require('lodash')
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      API_FRONTEND: process.env.API_FRONTEND,
      pickerMonthBat: false,
      pickerMonthPad: false,
      radioGroup: 0,
      StepCreate: 1,
      qrcode: [],
      CompanyMaintenance: '',
      CompanyOwner: '',
      SerialNum: '',
      NumQRcode: 1,
      ExpireBatPicker: new Date().toISOString().substr(0, 7),
      ExpirePadPicker: new Date().toISOString().substr(0, 7),
      itemsCompanyList: [],
      itemsCompanyOwner: [],
      authen: {},
      headerAPI: {},
      generate_id: '',
      dialogcreate_company: false,
      typeCompanyDecode: '',
      idCompany: '',
      API_FRONTEND: process.env.API_FRONTEND,
    }
  },
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.headerAPI = {Authorization: this.authen.Authorization}
    this.typeCompanyDecode = this.authen.typeCompany
    this.CompanyOwner = this.authen.idCompany
    this.getCompanyOwner()
    this.getCompanyMaintenance()
  },
  watch: {
    NumQRcode () {
      if (this. NumQRcode > 1000) {
        this.NumQRcode = 1000
        this.$swal( 'ไม่สำเร็จ', 'ไม่ควรเกิน 1000', 'error' )
      }
    },
    CompanyOwner () {
      this.CompanyMaintenance = ''
    }
  },
  components: {
    CreateCompany
  },
  computed: {
    ExpireBat () {
      const [year, month] = this.ExpireBatPicker.split('-')
      return `${month}/${year}`
    },
    ExpirePad () {
      const [year, month] = this.ExpirePadPicker.split('-')
      return `${month}/${year}`
    },
    itemsCompany () {
      return this.itemsCompanyList.filter(post => {
        return post.company_head.toLowerCase().includes(this.CompanyOwner.toLowerCase())
      })
    }
  },
  methods: {
    closecreate_company (value) {
      this.dialogcreate_company = value
      this.getCompanyMaintenance()
    },
    gotodetail () {
      // console.log('gotodetail')
      this.$router.push('/information_qrcode?id=' + this.generate_id)
    },
    successQrcode () {
      this.$swal( 'สำเร็จ', '', 'success' )
      this.StepCreate = 1
      this.radioGroup = 0
      this.qrcode = []
      this.CompanyMaintenance = ''
      this.CompanyOwner = ''
      this.SerialNum = ''
      this.NumQRcode = 1
      this.ExpireBatPicker = new Date().toISOString().substr(0, 7)
      this.ExpirePadPicker = new Date().toISOString().substr(0, 7)
    },
    CreateQRcode () {
      this.$swal({
        title: '<div class="Kanit">ยืนยันการสร้าง Qrcode</div>',
        // html: '<b class="Kanit">ยืนยันการสร้าง Qrcode</b><br><b class="Kanit">ยืนยันการสร้าง Qrcode</b>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          if (this.radioGroup == 1) {
            var body = {
              company_owner_id: this.CompanyOwner,
              company_maintenance_id: this.CompanyMaintenance,
              serial_number: this.SerialNum,
              pad_expire: this.ExpirePad,
              battery_expire: this.ExpireBat
            }
            this.axios.post(process.env.API_BACKEND + '/v1/genQrCodeByDetail', body, {headers: this.headerAPI}).then((response) => {
              if (response.data.message === 'serial_number_is_already') {
                this.$swal( 'ไม่สำเร็จ', 'Serial Number ซ้ำกับในระบบ', 'error' )
              } else if (response.data.message === 'success') {
                this.qrcode = [response.data.data]
                this.generate_id = response.data.data.generate_id
                this.StepCreate = 3
              }
            })
          } else if (this.radioGroup == 2) {
            var body = {
              company_owner_id: this.CompanyOwner,
              company_maintenance_id: this.CompanyMaintenance,
              number_qr_code_create: this.NumQRcode,
              pad_expire: this.ExpirePad,
              battery_expire: this.ExpireBat
            }
            this.axios.post(process.env.API_BACKEND + '/v1/genQrCodeByNumber', body, {headers: this.headerAPI}).then((response) => {
              if (response.data.message === 'success') {
                this.qrcode = response.data.data
                this.generate_id = response.data.data[0].generate_id
                this.StepCreate = 3
              } 
            })
          }
        }
      })
    },
    getCompanyMaintenance () {
      // console.log(this.headerAPI)
      this.axios.get(process.env.API_BACKEND + '/v1/getCompanyMaintenance', {headers: this.headerAPI}).then((response) => {
        // console.log(response.data.data)
        this.itemsCompanyList = response.data.data
      })
    },
    getCompanyOwner () {
      // console.log(this.headerAPI)
      this.axios.get(process.env.API_BACKEND + '/v1/getCompanyOwner', {headers: this.headerAPI}).then((response) => {
        // console.log(response.data.data)
        this.itemsCompanyOwner = response.data.data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>>.v-list-item .v-list-item__title {
    font-family: 'Kanit', sans-serif !important;

}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.horizontal-center {
  margin-left: auto;
  margin-right: auto;
}
/*>>>.theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
    border: #aa0800ff 2px solid;
}*/
/*>>>.theme--light.v-label {
    color: black !important;
}*/
/*>>>.theme--light.v-select .v-select__selections {
    color: rgb(168, 13, 0) !important;
}*/

.pd-10 {
  padding: 10px !important;
}
.toolbarqrcode {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}
>>>.v-input--selection-controls .v-radio>.v-label {
  color: black;
  }
  .widthdivstep {
    width: 50vw;
    margin-top: 10px;
  }

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px), (min-width: 768px) and (max-width: 1024px)  {
  .widthdivstep {
    width: 86vw;
    margin-top: 10px;
  }
  
}

</style>



// WEBPACK FOOTER //
// src/components/genqrcode.vue